import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiListModule } from "@snelstart/ui-list";
import { SharedUiLoadingModule } from "@snelstart/ui-loading";
import { SharedUiOffCanvasModule } from "@snelstart/ui-off-canvas";
import { FeatureTaxSbaDetailsComponent } from "./tax-sba-details/feature-tax-sba-details.component";
import {SbaComponent} from "./sba/sba.component";

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiListModule,
    SharedUiLoadingModule,
    SharedUiOffCanvasModule,
    SbaComponent,
    FeatureTaxSbaDetailsComponent
  ],
  declarations: [

  ],
  exports: [FeatureTaxSbaDetailsComponent],
})
export class FeatureTaxSbaDetailsModule {}
